import { JobStatus, JobType } from '@kcftech/prometheustypescriptapiclient';
import { Lookup } from 'utils/types';

// TODO: this should be a mapping returned by the API
export const jobTypeToName: Lookup<JobType, string> = {
    SensorAssignment: 'Sensor Assignment',
    SystemCreation: 'System Creation',
    EditAssetDetails: 'Edit Asset Details',
    EditIndicators: 'Edit Indicators',
    EditGroups: '',
};

export const jobStatusToName: Lookup<JobStatus, string> = {
    Queued: 'Queued',
    Running: 'Running',
    Finished: 'Finished',
    FinishedWithErrors: 'Finished with errors',
    Errored: 'Errored',
    Deferred: 'Deferred',
};
